import React, {
  useContext,
  useMemo,
  useEffect,
  useState,
  useCallback,
  useRef,
} from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { DesignContext } from 'contexts/DesignContext'
import { Form, Button, Row, Col } from 'react-bootstrap'
import colorContrast from 'color-contrast'
import { useDropzone } from 'react-dropzone'
import objectPath from 'object-path'
import httpClient from 'utility/httpClient.util'
import PNotify from 'pnotify/dist/es/PNotify'
import feather from 'feather-icons'

import { debounceCallback } from 'utility/debounceCallback.util'
import { createDesignerData } from 'designer/component/action/Design'
import {
  checkConditionApi,
  checkPropTab,
  createApiSchema,
  fetchAfterSuccess,
  getApi,
  mapResponseData,
  setHeadersConfig,
} from 'designer/component/action/Api'
import Icon from './Icon'
import { onCheckCondition, onUpdateCondition } from '../action/condition/Action'
import { useFormikContext } from 'formik'
import checkError, { getValidationAlertTitle } from '../validation'
import useAuth from 'hooks/useAuth'
import _ from 'lodash'
import { getCompareValue, isEmpty } from '../action/condition/State'
import {
  backToReport,
  goToForm,
  goToPage,
  goToUrl,
  print,
  setHistoryData,
} from './button/GoTo'
import { closeModal, openModal } from './button/Modal'
import {
  callbackFunction,
  focusInput,
  onAlert,
  onBeforeAlert,
  resetKey,
  resetData,
  showAndHide,
} from './button/ButtonAction'
import { fetchData } from './button/API'
import { updateSearchAPI, updateSearchField } from './button/Search'
import { refreshGallery, saveMedia, uploadFile } from './button/Media'
import {
  addToTable,
  updateToTable,
  refreshTable,
  unselectRow,
} from './button/Table'
import {
  checkDefaultValue,
  checkExceptRequest,
  checkExceptRowData,
  convertValueBySchema,
  createCustomRequest,
  createMultiSelectRequest,
  setRequestFormData,
  setRequestWidget,
} from './button/Request'
import { compareTwoValue, isFile } from '../action/Data'
import SmartCard, { openSmartCard } from './button/SmartCard'
import Capture from './button/Capture'
import Label from './Label'
import AttachmentView from './AttachmentView'
import { Resolver } from '@stoplight/json-ref-resolver'
import ModalButton from '../component/ModalButton'
import { getShowUiConfig } from '../action/Config'
import { getFormGroup } from '../action/FormGroup'
import { Tooltip } from '@mui/material'
import Swal from 'sweetalert2'
import { openDrawing } from './button/Drawing'
import { Refresh } from '@mui/icons-material'
import { refreshComponent } from './button/Component'
import { hasRules, onUpdateRules } from '../rules/Action'
import {
  createTriggerButtonResultWithValidate,
  createTriggerButtonValidateResponse,
  shouldStopTriggerButtonAction,
} from './button/TriggerButtonValidate'
import {
  getActionListFormData,
  getResponseFormData,
  hasResponseFormData,
} from './button/ActionFormData'
import {
  getActionResetKeyList,
  getActionResponseResetKeyList,
} from './button/ResetFormGroup'
import {
  applyRequestTimeout,
  withRequestTimeout,
} from '../action/RequestTimeout'

const DEBOUNCE_SAVE_DELAY_MS = 60000

const getTriggerButtonScopeKey = (designContext = {}) => {
  let { formDesign = {}, jsonForm = {} } = designContext

  return (
    formDesign.code ||
    jsonForm.formCode ||
    formDesign.formDesignId ||
    jsonForm.formDesignId ||
    ''
  )
}

export const CustomButton = (props) => {
  let {
    uischema = {},
    disabled = false,
    onCustomClick = null,
    customClick = false,
    label,
    actionOnly = false,
    renderAction = null,
  } = props

  const formikContext = useFormikContext()
  const { errors, setValues } = formikContext
  const { config, user } = useAuth()
  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    setOpenModal,
    setFormData,
    dataGET,
    setDataGET,
    setDesignerPropsData,
    searchData,
    setIsResetData,
    elementAction,
    setElementAction,
    setDatasourceValue,
    getCurrentUi,
    activeButton,
    setActiveButton,
    tabParamActive,
    isUiChanged,
    setIsUiChanged,
    detailPanelProps = {},
    isModal,
  } = designContext
  const allFormGroup = getFormGroup(designContext)
  let isShowUi = getShowUiConfig({
    uischema,
    config,
    jsonForm,
  })

  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    isArray,
    arrayName,
  } = props?.config || {}

  const fieldName =
    props?.fieldName || isArray
      ? `@${arrayName}.${uischema.name}`
      : isDynamic
      ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
      : uischema.name
  const fieldKey =
    props?.fieldKey || isArray
      ? `@${arrayName}.${uischema.key}`
      : isDynamic
      ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
      : uischema.key

  let buttonKey = uischema.key
  let triggerButtonScopeKey = getTriggerButtonScopeKey(designContext)
  let triggerButtonUiChanged = triggerButtonScopeKey
    ? objectPath.get(isUiChanged, [
        'triggerButton',
        triggerButtonScopeKey,
        buttonKey,
      ])
    : null

  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  const triggerModal = isUiChanged?.triggerModal || {}

  let history = useHistory()
  const match = useRouteMatch()
  const location = useLocation()
  let action = objectPath.get(uischema, 'action') || {}
  let formData = objectPath.get(jsonForm, 'formData') || {}
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  let designerData = objectPath.get(designerPropsData, 'data') || {}
  let systemData = jsonForm.systemData
  let rowData = objectPath.get(jsonForm, 'componentPropsData.rowData')
  const saveKey = action?.save?.key ?? `@attachments.${buttonKey}`
  const isBrowseAction = action.name === 'browseFile'
  let attachments = isBrowseAction
    ? objectPath.get(formData, saveKey) || []
    : null
  const isShowAttachmentView = !action?.save?.key && isBrowseAction

  const search = location.search || []
  const receivePathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const receiveQueryParams = Object.fromEntries([...urlSearchParams])
  const allParams = { ...receivePathParams, ...receiveQueryParams }
  const hasEnable = objectPath.has(elementAction, ['isEnable', buttonKey])
  const isEnable = objectPath.get(elementAction, ['isEnable', buttonKey])
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  const mapFormData = objectPath.get(jsonForm, 'schema.mapFormData')
  const [isLoading, setIsLoading] = useState(false)
  const [loadingText, setLoadingText] = useState('Loading...')
  const [modalAction, setModalAction] = useState({})
  const [openSmartCard, setOpenSmartCard] = useState(false)
  const [openCapture, setOpenCapture] = useState(false)
  const [drawing, setDrawing] = useState(null)

  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return false
  }, [isEnable])

  let data = {
    formData,
    allParams,
    user,
    datasourceValue,
    designerData,
    systemData,
    searchData,
  }

  const [buttonText, buttonType, buttonColor] = useMemo(() => {
    let { titleValue, buttonType, buttonColor } = uischema?.valuePattern || {}
    let foundValue
    if (titleValue) {
      let pattern = []
      titleValue.forEach(({ patternList = [] }) => {
        let subPattern = ''
        patternList.forEach((item) => {
          let { value, groupType, key, isTabParam } = item
          let isNew = objectPath.get(item, '__isNew__')
          if (isTabParam) {
            let containerKey = item.tabKey
            let paramName = item.name
            value = checkPropTab({ designContext }, { containerKey, paramName })
            foundValue = value
          } else if (!isNew) {
            value = getCompareValue(key, '', groupType, data)
            foundValue = value
          }
          subPattern += value
        })
        pattern.push(subPattern)
      })
      if (foundValue) {
        return [pattern.join(' '), buttonType, buttonColor]
      }
    }
    return [uischema.buttonText, uischema.buttonType, uischema.buttonColor]
  }, [
    uischema.buttonText,
    uischema.buttonType,
    uischema.buttonColor,
    JSON.stringify(tabParamActive),
  ])

  const isDisable = useMemo(() => {
    if (hasEnable) {
      let isDisable = isEnable === false ? true : false
      return isDisable
    }
    return disabled
  }, [buttonKey, isEnable])

  const postData = async (
    action,
    dataGET,
    formData,
    { files, api, requestData },
  ) => {
    if (!api) {
      // set api
      api = getApi(action, { dataGET, formData, designContext })
      if (!api)
        return {
          status: -2,
          message: 'No API',
          data: null,
          requestData: null,
        }
    }
    if (!requestData) {
      // set request body
      requestData = await setRequestData(action, formData, files)
      let isEmpty = checkEmptyRequest(action, requestData)
      if (isEmpty) {
        return {
          status: -2,
          message: 'Empty Payload',
          data: null,
          requestData,
        }
      }
    }
    // set headers config
    let config = applyRequestTimeout(setHeadersConfig(action), action)
    // send request
    console.log('postData', { api, requestData })
    let response = await withRequestTimeout(
      httpClient.post(api, requestData, config),
      action,
    )
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        return {
          status: error.response?.status || 500,
          message: error.response?.data || error.message,
          data: null,
        }
      })
    return response
  }

  const putData = async (
    action,
    dataGET,
    formData,
    { files, api, requestData },
  ) => {
    if (!api) {
      // set api
      api = getApi(action, { dataGET, formData, designContext })
      if (!api)
        return {
          status: -2,
          message: 'No API',
          data: null,
          requestData: null,
        }
    }
    if (!requestData) {
      // set request body
      requestData = await setRequestData(action, formData, files)
      let isEmpty = checkEmptyRequest(action, requestData)
      if (isEmpty) {
        return {
          status: -2,
          message: 'Empty Payload',
          data: null,
          requestData,
        }
      }
    }
    // set headers config
    let config = applyRequestTimeout(setHeadersConfig(action), action)
    // send request
    console.log('putData', { api, requestData })
    let response = await withRequestTimeout(
      httpClient.put(api, requestData, config),
      action,
    )
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        return {
          status: error.response?.status || 500,
          message: error.response?.data || error.message,
          data: null,
        }
      })

    return response
  }

  const patchData = async (
    action,
    dataGET,
    formData,
    { files, api, requestData },
  ) => {
    // set api
    if (!api) {
      // set api
      api = getApi(action, { dataGET, formData, designContext })
      if (!api)
        return {
          status: -2,
          message: 'No API',
          data: null,
          requestData: null,
        }
    }
    if (!requestData) {
      // set request body
      requestData = await setRequestData(action, formData, files)
      let isEmpty = checkEmptyRequest(action, requestData)
      if (isEmpty) {
        return {
          status: -2,
          message: 'Empty Payload',
          data: null,
          requestData,
        }
      }
    }
    // set headers config
    let config = applyRequestTimeout(setHeadersConfig(action), action)
    // send request
    console.log('patchData', { api, requestData })
    let response = await withRequestTimeout(
      httpClient.patch(api, requestData, config),
      action,
    )
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        return {
          status: error.response?.status || 500,
          message: error.response?.data || error.message,
          data: null,
        }
      })

    return response
  }

  const deleteData = async (action, dataGET, formData, { api }) => {
    // set api
    if (!api) {
      // set api
      api = getApi(action, { dataGET, formData, designContext })
      if (!api)
        return {
          status: -2,
          message: 'No API',
          data: null,
          requestData: null,
        }
    }
    // set headers config
    let config = applyRequestTimeout(setHeadersConfig(action), action)
    // send request
    console.log('deleteData', { api })
    let response = await withRequestTimeout(
      httpClient.delete(api, config),
      action,
    )
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        return {
          status: error.response?.status || 500,
          message: error.response?.data || error.message,
          data: null,
        }
      })
    return response
  }

  const getData = async (action, dataGET, formData) => {
    let { responseDataType, customName, dataKey = '', dataTable } = action

    let api = getApi(action, { dataGET, formData, designContext })
    if (!api)
      return {
        status: -2,
        message: 'No API',
        data: null,
        requestData: null,
      }

    // set headers config
    let config = setHeadersConfig(action)
    // send request
    console.log('getData', { api })
    let response = await httpClient
      .get(api, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })

    if (response?.status !== 200) {
      let propType = objectPath.get(designerPropsData, `propType`) || {}
      let filterProp = Object.keys(propType)
      filterProp.forEach((key) => {
        let [componentKey, dataKey] = key.split('/')
        if (propType[key] === 'formData') {
          objectPath.set(
            designerPropsData,
            `data.${componentKey}.${dataKey}`,
            {},
          )
        } else {
          objectPath.set(
            designerPropsData,
            `data.${componentKey}.${dataKey}`,
            '',
          )
        }
      })
      return response
    }
    let responseData = objectPath.get(response.data, dataKey)
    objectPath.set(datasourceValue, `${action.key}`, responseData)
    setDatasourceValue(datasourceValue)
    const resolver = new Resolver()
    let apiSchema = await createApiSchema(action, designContext, resolver)
    let internalSchema = objectPath.get(apiSchema, 'properties') || {}
    // set form data
    if (responseDataType === 'customData') {
      dataTable.forEach((data) => {
        let value = objectPath.get(responseData, data.response)
        let valueType = internalSchema[data.response]?.type
        if (value === undefined) {
          if (valueType === 'string') {
            value = ''
          } else if (valueType === 'array') {
            value = []
          } else if (valueType === 'object') {
            value = {}
          } else {
            value = null
          }
        }
        if (data.key && data.response) {
          objectPath.set(formData, data.key, value)
        }
        if (data.response) {
          objectPath.set(formData, data.response, value)
        }
      })
      if (customName) {
        objectPath.set(formData, `props.${formData}`, responseData || {})
      }
    } else if (responseDataType === 'formData') {
      dataTable.forEach(
        ({
          response,
          key,
          dynamicName,
          isDynamic,
          isComponentData,
          componentName,
        }) => {
          let value = objectPath.get(responseData, response)
          let valueType = internalSchema[response]?.type
          if (value === undefined) {
            if (valueType === 'string') {
              value = ''
            } else if (valueType === 'array') {
              value = []
            } else if (valueType === 'object') {
              value = {}
            } else {
              value = null
            }
          }
          if (isComponentData && componentName) {
            objectPath.set(formData, `${componentName}.${response}`, value)
          }

          if (isDynamic) {
            objectPath.set(formData, dynamicName, value)
          } else if (key && response) {
            objectPath.set(formData, key, value)
          } else if (response) {
            objectPath.set(formData, response, value)
          }
        },
      )
    }
    return response
  }

  const getSubValue = (splitValue, data, requestArray) => {
    let shiftKey = splitValue.shift()
    if (shiftKey === '#') {
      return getSubValue(splitValue, data, requestArray)
    }
    let hasKey = objectPath.has(data, shiftKey)
    if (hasKey) {
      data = objectPath.get(data, shiftKey)
    }
    if (splitValue.length === 0) {
      if (hasKey) {
        return data
      }
      if (Array.isArray(data) && data.length > 0) {
        hasKey = objectPath.get(data, `${0}.${shiftKey}`)
        if (hasKey) {
          let itemRequest = {}
          data.forEach((dataValue) => {
            let itemValue = objectPath.get(dataValue, shiftKey)
            objectPath.set(itemRequest, shiftKey, itemValue)
          })
        }
      }
      return requestArray
    }
    return getSubValue(splitValue, data, requestArray)
  }

  const createFormDataRequest = ({
    formData,
    data,
    requestBody,
    action,
    designContext,
    apiSchema,
    rowData,
  }) => {
    let formDataList = action?.formDataList
    if (formDataList) {
      formDataList.forEach((formItem) => {
        let form = allFormGroup.find((form) => form.key === formItem.key)
        if (!form) return requestBody
        let isComponentData = !form.isSystem
        let { isWidget, isFormComponent, formComponentName } = form
        if (isFormComponent) {
          let formComponentData = objectPath.get(formData, formComponentName)
          requestBody = setRequestFormData({
            form: form,
            data: { ...data, formData: { ...formData, ...formComponentData } },
            requestBody,
            designContext,
            apiSchema,
          })
        } else if (isWidget) {
          requestBody = setRequestWidget({
            form,
            data,
            requestBody,
            action,
            formData,
            apiSchema,
            jsonForm,
            rowData,
          })
        } else if (isComponentData) {
          requestBody = setRequestFormData({
            form: formItem,
            data,
            requestBody,
            designContext,
            apiSchema,
          })
        } else if (form.isGroup) {
          let groupData = form.groupData || []
          groupData.forEach((subGroup) => {
            requestBody = setRequestFormData({
              form: { ...subGroup, isGroup: true, isSystem: true },
              data,
              requestBody,
              designContext,
              apiSchema,
            })
          })
        } else {
          requestBody = setRequestFormData({
            form,
            data,
            requestBody,
            designContext,
            apiSchema,
          })
        }
      })
    }
    return requestBody
  }

  const createFormConditionDataRequest = ({
    formData,
    data,
    requestBody,
    action,
    designContext,
    apiSchema,
  }) => {
    let { formConditionData } = action
    if (!formConditionData) return requestBody
    let isDynamic = false
    let dynamicCheck = []
    let found = formConditionData.find((condition) => {
      let { valueType = 'equalValue', valueKey, compareValue } = condition
      let ui = getCurrentUi(valueKey, jsonForm.schema, jsonForm.uischema)
      if (ui.key !== valueKey) return false
      let { isInsideDynamic } = ui
      if (isInsideDynamic) {
        let { dynamicKey, dynamicName } = ui
        let dynamicData = objectPath.get(formData, dynamicName)
        if (dynamicData) {
          dynamicData.forEach((rowData, index) => {
            let conditionValue = objectPath.get(rowData, valueKey)
            let compare = compareTwoValue(
              valueType,
              conditionValue,
              compareValue,
            )
            if (compare) {
              let dynamicUi = getCurrentUi(
                dynamicKey,
                jsonForm.schema,
                jsonForm.uischema,
              )
              dynamicCheck.push({
                condition,
                dynamicKey,
                dynamicName,
                dynamicIndex: index,
                dynamicUi,
                rowData,
              })
            }
          })
          isDynamic = true
        }
      } else {
        let conditionValue =
          objectPath.get(formData, valueKey) || objectPath.get(data, valueKey)
        if (conditionValue === undefined) {
          conditionValue = checkDefaultValue(valueKey, jsonForm, { ui })
        }
        let compare = compareTwoValue(valueType, conditionValue, compareValue)
        return compare
      }
    })
    if (isDynamic) {
      let requestBodyList = []
      let currentSeq = 0
      let { exceptField } = action
      dynamicCheck.forEach((item, index) => {
        let requestBody = {}
        let { condition, rowData, dynamicUi } = item
        let startSeq = dynamicUi?.startSeq
        if (currentSeq === 0) {
          currentSeq = startSeq
        }
        if (objectPath.get(rowData, '@isDeleted') === 1) {
          objectPath.set(rowData, '@seq', null)
        } else {
          objectPath.set(rowData, '@seq', currentSeq)
          currentSeq++
        }
        let keyList = condition?.formData
        let isExceptRequest = false
        keyList.forEach((item) => {
          let itemKey = item.key
          let itemName = item.value
          let requestKey = item.request
          let dataType = item.dataType
          if (dataType === 'input') {
            let ui = getCurrentUi(item.key, jsonForm.schema, jsonForm.uischema)
            if (ui.key === itemKey) {
              itemName = ui.name
            }
          }
          let value =
            objectPath.get(rowData, itemName) ||
            objectPath.get(rowData, requestKey)
          value = convertValueBySchema(apiSchema, requestKey, value)
          let except = exceptField.find((item) => item.request === requestKey)
          if (except) {
            let { exceptEmpty, exceptUndefined } = except
            let isExceptEmpty = isEmpty(value)
            let isExceptUndefined = value === undefined
            if (!exceptEmpty && !exceptUndefined) return
            if (isExceptEmpty || isExceptUndefined) {
              isExceptRequest = true
            }
          }
          if (value !== undefined) {
            objectPath.set(requestBody, requestKey, value)
          }
        })
        if (!isExceptRequest) {
          requestBodyList.push(requestBody)
        }
      })
      return requestBodyList
    } else {
      if (found) {
        requestBody = createFormDataRequest({
          formData,
          data,
          requestBody,
          action: found,
          designContext,
          apiSchema,
        })
      }
    }
    return requestBody
  }

  const setRequestData = async (action, formData, files) => {
    let { requestDataType } = action
    const resolver = new Resolver()
    let apiSchema = await createApiSchema(action, designContext, resolver)
    if (requestDataType === 'noRequest') {
      return undefined
    }
    let requestBody = {}
    if (requestDataType === 'customData') {
      let { customData = [] } = action
      customData.forEach((subAction) => {
        let { request, value } = subAction
        value = createCustomRequest({
          mainAction: action,
          action: subAction,
          data,
          designContext,
          apiSchema,
        })
        requestBody = checkExceptRequest(action, requestBody, request, value)
      })
    } else if (requestDataType === 'formData') {
      requestBody = createFormDataRequest({
        formData,
        data,
        requestBody,
        action,
        designContext,
        apiSchema,
      })
    } else if (requestDataType === 'formConditionData') {
      requestBody = createFormConditionDataRequest({
        formData,
        data,
        requestBody,
        action,
        designContext,
        apiSchema,
      })
    } else if (requestDataType === 'file') {
      let { fileKey } = action
      if (fileKey) {
        let acceptedFiles = objectPath.get(formData, fileKey)
        const files = new FormData()
        let hasNewFile = false
        for (const file of acceptedFiles) {
          if (isFile(file)) {
            files.append('file', file)
            hasNewFile = true
          }
        }
        requestBody = hasNewFile ? files : null
      } else {
        requestBody = files
      }
    } else if (requestDataType === 'bulkData') {
      let bulkKey = objectPath.get(action, 'bulkKey')
      let bulkConditionData = objectPath.get(action, 'bulkConditionData')
      let bulkData = objectPath.get(action, 'bulkData')
      let dataKey = objectPath.get(bulkData, 'dataKey')
      let { key, apiKey, isResponse, isWidget, formCode, widgetUiName, value } =
        bulkData

      let ui
      let jsonForm
      if (isWidget && formCode) {
        let { widgetDesign } = designContext
        if (!widgetDesign) return requestBody
        jsonForm = objectPath.get(widgetDesign, [bulkData.formCode])
      } else {
        jsonForm = designContext.jsonForm
      }
      if (jsonForm) {
        ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      }
      console.log('bulkData ui', ui)
      if (!ui) return requestBody

      let bulkRequests = []
      let bulkItems = []
      if (isResponse) {
        let valueKey = dataKey ? `${dataKey}.${key}` : key
        bulkItems = objectPath.get(formData, `@response.${apiKey}.${valueKey}`)
        if (!bulkItems) {
          bulkItems = objectPath.get(formData, `@response.${apiKey}.${dataKey}`)
        }
      } else {
        if (ui.key === key) {
          let isBrowseGallery = ui.galleryType === 'browse'
          if (isBrowseGallery) {
            bulkItems = objectPath.get(formData, `@browseGallery.${key}`)
          } else if (isWidget) {
            if (objectPath.has(formData, `${widgetUiName}.${value}`)) {
              bulkItems = objectPath.get(formData, `${widgetUiName}.${value}`)
            } else {
              bulkItems = objectPath.get(formData, value)
            }
          } else {
            bulkItems = objectPath.get(formData, key)
          }
        } else {
          bulkItems = objectPath.get(formData, key)
        }
      }

      if (bulkItems) {
        if (bulkConditionData && bulkConditionData?.length > 0) {
          bulkItems = bulkItems.filter((rowData) => {
            return bulkConditionData.find((condition) => {
              let { valueName, valueType, compareValue } = condition
              let valueKey = condition.value
              let conditionValue
              if (valueName) {
                conditionValue =
                  objectPath.get(rowData, valueName) ||
                  objectPath.get(rowData, valueKey)
              } else {
                conditionValue = objectPath.get(rowData, valueKey)
              }
              return compareTwoValue(valueType, conditionValue, compareValue)
            })
          })
        }
        bulkItems.forEach((item) => {
          let bulkRequest = {}
          let isEmptyBulk = false
          bulkKey.forEach((subAction) => {
            let {
              apiKey,
              dataKey,
              request,
              propType,
              value,
              key = '',
              required = false,
            } = subAction
            value = createCustomRequest({
              mainAction: action,
              action: subAction,
              data,
              designContext,
              apiSchema,
              isCheckSchema: false,
            })
            if (propType === 'gallery') {
              value = objectPath.get(item, value)
            } else if (propType === 'dynamicData' || propType === 'bulkItem') {
              if (request === 'deleteMode') {
                value = objectPath.get(item, '@isDeleted') ? 1 : undefined
              } else if (request && objectPath.has(item, request)) {
                value = objectPath.get(item, request)
              } else if (action.value && objectPath.has(item, action.value)) {
                value = objectPath.get(item, action.value)
              } else {
                value = undefined
              }
              if (required && isEmpty(value)) {
                isEmptyBulk = true
              }
            } else if (propType === 'table') {
              value = objectPath.get(item, key)
            } else if (propType === 'response') {
              if (objectPath.has(item, key)) {
                value = objectPath.get(item, key)
              } else {
                value = objectPath.get(
                  formData,
                  `@response.${apiKey}.${dataKey}.${key}`,
                )
              }
            }
            value = convertValueBySchema(apiSchema, request, value)
            if (value !== undefined) {
              objectPath.set(bulkRequest, request, value)
            }
          })
          if (!isEmptyBulk) {
            bulkRequests.push(bulkRequest)
          }
        })
      }
      requestBody = bulkRequests
    } else if (requestDataType === 'selectRow') {
      if (!rowData) return requestBody
      let { customData = [] } = action
      customData.forEach((subAction) => {
        let { request, value } = subAction
        value = createCustomRequest({
          mainAction: action,
          action: subAction,
          data,
          rowData,
          designContext,
          apiSchema,
        })
        requestBody = checkExceptRequest(action, requestBody, request, value)
      })
    } else if (requestDataType === 'multiSelect') {
      requestBody = createMultiSelectRequest({
        action,
        data,
        designContext,
        apiSchema,
      })
    } else if (
      requestDataType === 'table' ||
      requestDataType === 'tableSelection'
    ) {
      let {
        customData = [],
        tableKey,
        tableName,
        formComponentName,
        jsonTableKey,
        isCreateOnly,
      } = action
      tableKey = formComponentName
        ? `${formComponentName}.${tableKey}`
        : tableKey
      tableName = formComponentName
        ? `${formComponentName}.${tableName}`
        : tableName
      let tableData
      if (requestDataType === 'table') {
        tableData =
          objectPath.get(formData, tableName) ||
          objectPath.get(formData, tableKey)
      } else if (requestDataType === 'tableSelection') {
        tableData = objectPath.get(isUiChanged, ['tableSelection', tableKey])
      }
      let tableUi = getCurrentUi(tableKey, jsonForm.schema, jsonForm.uischema)
      let { tableColumn = [] } = tableUi
      let columnRefId = objectPath.get(tableUi, 'loadData.columnRefId')
      let arrayRequest = []
      if (tableData && Array.isArray(tableData)) {
        let seq = 1
        tableData.forEach((rowData) => {
          let isDeleted = objectPath.get(rowData, '@isDeleted')
          if (requestDataType === 'table') {
            let id
            if (columnRefId) {
              id = objectPath.get(rowData, columnRefId)
            }
            let hasId = id ? true : false
            if (hasId && isCreateOnly) {
              if (!isDeleted) return
            }
          }
          let itemRequest = {}
          customData.forEach((subAction) => {
            let { request, value } = subAction
            let foundColumn = tableColumn.find(
              (column) => column.field === subAction.key,
            )
            subAction = { ...subAction, type: foundColumn?.type }
            value = createCustomRequest({
              mainAction: action,
              action: subAction,
              data: { ...data, rowData, autoSeq: seq },
              designContext,
              apiSchema,
            })
            if (request === 'deleteMode' && isDeleted) {
              objectPath.set(itemRequest, request, value)
            } else if (request === 'seq') {
              objectPath.set(itemRequest, request, seq)
            } else if (value !== undefined) {
              objectPath.set(itemRequest, request, value)
            }
          })
          let isExcept = checkExceptRowData(action, itemRequest)
          if (!isExcept) {
            arrayRequest.push(itemRequest)
          }
          if (!isDeleted) {
            seq += 1
          }
        })
      }
      if (jsonTableKey) {
        objectPath.set(requestBody, jsonTableKey, arrayRequest)
      } else {
        requestBody = arrayRequest
      }
    }
    return requestBody
  }

  const onBrowseFile = async (
    apiGroup,
    formData,
    acceptedFiles = [],
    isAlreadyCheckCondition = false,
  ) => {
    if (!Array.isArray(acceptedFiles)) return []

    if (acceptedFiles.length === 0) return []
    const files = new FormData()
    for (const file of acceptedFiles) {
      let isFileType = file instanceof File
      if (isFileType) {
        files.append('file', file)
      }
    }

    let promiseList = []
    let filterApi = []

    if (isAlreadyCheckCondition) {
      filterApi = apiGroup
    } else {
      filterApi = apiGroup.filter((item) => {
        if (item.method === 'get') {
          return checkConditionApi(
            item,
            allParams,
            formData,
            datasourceValue,
            tabParamActive,
          )
        }
        if (item.method === 'post') {
          return checkConditionApi(
            item,
            allParams,
            formData,
            datasourceValue,
            tabParamActive,
          )
        }
        if (item.method === 'put') {
          return checkConditionApi(
            item,
            allParams,
            formData,
            datasourceValue,
            tabParamActive,
          )
        }
        if (item.method === 'patch') {
          return checkConditionApi(
            item,
            allParams,
            formData,
            datasourceValue,
            tabParamActive,
          )
        }
        if (item.method === 'delete') {
          return checkConditionApi(
            item,
            allParams,
            formData,
            datasourceValue,
            tabParamActive,
          )
        }
        return false
      })
    }

    let responseData = formData
    filterApi.map(async (item) => {
      let promise = new Promise(async (resolve, reject) => {
        let response = {}
        let data = null
        let status = null
        let message = ''
        let awaitPromised = await Promise.all(promiseList)
        awaitPromised.forEach(({ data }) => {
          responseData = { ...responseData, ...(data?.data || {}) }
        })

        if (item.method === 'get') {
          response = await getData(item, {}, formData)
        } else if (item.method === 'post') {
          response = await postData(item, {}, responseData, { files })
        } else if (item.method === 'put') {
          response = await putData(item, {}, responseData, { files })
        } else if (item.method === 'patch') {
          response = await patchData(item, {}, responseData, { files })
        } else if (item.method === 'delete') {
          response = await deleteData(item, {}, formData, {})
        }
        data = response?.data
        message = response?.message
        status = response?.status

        if (data) {
          objectPath.set(formData, `@response.${item.key}`, data)
          setFormData(formData)
        }

        if (status >= 400) {
          reject({
            status: status,
            data: null,
            message: message,
            api: item.api,
            apiName: item.apiName,
          })
        } else {
          resolve({
            status: status,
            data: data,
            message: message,
            api: item.api,
            apiName: item.apiName,
          })
        }
      })
        .then((response) => response)
        .catch((error) => error)
      promiseList.push(promise)
    })

    return await Promise.all(promiseList)
  }

  const onDrop = useCallback((acceptedFiles) => {
    let action = uischema.action
    let { save = {}, browseFile = {} } = action
    let apiGroup = browseFile.apiGroup
    if (save?.type === 'api' && apiGroup) {
      new Promise(async (resolve) => {
        let apiGroup = objectPath.get(action, 'browseFile.apiGroup') || []
        let browsePromise = await onBrowseFile(
          apiGroup,
          formData,
          acceptedFiles,
        )
        browsePromise.forEach((response = {}) => {
          let { status, data = null } = response
          if (status === null) return
          if (data) {
            formData = { ...formData, ...data }
          }
        })
        resolve(save?.key, formData)
      }).then((galleryKey, formData) => {
        objectPath.set(isUiChanged, galleryKey, { isAPI: true })
        setIsUiChanged(isUiChanged)
        setFormData(formData)
      })
    } else if (save?.type === 'array') {
      acceptedFiles.forEach(async (file) => {
        const src = URL.createObjectURL(file)
        objectPath.set(file, 'contentType', file.type)
        objectPath.set(file, 'ext', file.path.split('.').pop())
        objectPath.set(file, 'src', src)
        attachments.push(file)
        objectPath.set(formData, saveKey, attachments)
        objectPath.set(isUiChanged, save?.key ?? buttonKey, { isRender: true })
        setFormData(formData)
        setIsUiChanged(isUiChanged)
      })
    }
  }, [])

  const { open } = useDropzone({
    onDrop,
  })

  const saveSequence = async (
    item,
    index,
    promiseList,
    apiSaveUpdate,
    formData,
  ) => {
    let promise = await new Promise(async (resolve, reject) => {
      let get = item.get
      let found = item.found
      let notfound = item.notfound
      let key = item.getKey
      let responseGET = await getData(get, dataGET[key], formData)
      let statusGET = responseGET.status
      let response = {}
      let status = null
      let data = null
      let message = null

      if (statusGET >= 400) {
        if (notfound.method === 'post') {
          response = await postData(notfound, {}, formData, {})
        }
        if (notfound.method === 'put') {
          response = await putData(notfound, {}, formData, {})
        }
        if (notfound.method === 'patch') {
          response = await patchData(notfound, {}, formData, {})
        }
        data = response.data
        status = response.status
        message = response.message

        if (data) {
          objectPath.set(formData, `@response.${notfound.key}`, data)
          setFormData(formData)
        }

        if (status >= 400) {
          reject({
            status: status,
            data: data,
            api: notfound.api,
            apiName: notfound.apiName,
            message: message,
          })
        } else {
          setDataGET({ [key]: data })
          resolve({
            status: status,
            data: data,
            api: notfound.api,
            apiName: notfound.apiName,
            message: message,
          })
        }
      } else {
        let dataGET = responseGET.data
        if (found.method === 'post') {
          response = await postData(found, dataGET, formData, {})
        }
        if (found.method === 'put') {
          response = await putData(found, dataGET, formData, {})
        }
        if (found.method === 'patch') {
          response = await patchData(found, dataGET, formData, {})
        }
        data = response.data
        status = response.status
        message = response.message

        if (data) {
          objectPath.set(formData, `@response.${found.key}`, data)
          setFormData(formData)
        }

        if (status >= 400) {
          reject({
            status: status,
            data: data,
            api: found.api,
            apiName: found.apiName,
            message: message,
          })
        } else {
          setDataGET({ [key]: data })
          resolve({
            status: status,
            data: data,
            api: found.api,
            apiName: found.apiName,
            message: message,
          })
        }
      }
    })
      .then((response) => response)
      .catch((error) => error)
    promiseList.push(promise)

    index++
    if (apiSaveUpdate[index]) {
      item = apiSaveUpdate[index]
      promiseList = await saveSequence(
        item,
        index,
        promiseList,
        apiSaveUpdate,
        formData,
      )
    }

    return promiseList
  }

  const checkEmptyRequest = (action, requestData) => {
    let { requestDataType } = action
    if (requestDataType !== 'noRequest') {
      if (
        !requestData ||
        (requestDataType !== 'file' && _.isEmpty(requestData))
      ) {
        return true
      }
    }
    return false
  }

  const saveMultiRequest = async (action, dataGET, responseData) => {
    let method = action?.method || ''
    let methodTitle = method.toUpperCase()
    let api = getApi(action, { dataGET, responseData, designContext })
    if (!api)
      return {
        status: -2,
        message: 'No API',
        data: null,
        requestData: null,
      }
    // set request body
    let requestDataList = await setRequestData(action, responseData)
    let isEmpty = checkEmptyRequest(action, requestDataList)
    if (isEmpty) {
      return {
        status: -2,
        message: 'Empty Payload',
        data: null,
        requestData: requestDataList,
      }
    }
    // send request
    if (!Array.isArray(requestDataList)) {
      return {
        status: -2,
        message: 'Incorrect Format Payload',
        data: null,
        requestData: requestDataList,
      }
    }

    let promiseList = []
    requestDataList.map(async (requestData) => {
      let promise = new Promise(async (resolve, reject) => {
        let response = {}
        let data = null
        let status = null
        let message = ''
        let awaitPromised = await Promise.all(promiseList)
        awaitPromised.forEach(({ data }) => {
          responseData = { ...responseData, ...(data?.data || {}) }
        })
        if (method === 'post') {
          response = await postData(action, {}, responseData, {
            api,
            requestData,
          })
        } else if (method === 'put') {
          response = await putData(action, {}, responseData, {
            api,
            requestData,
          })
        } else if (method === 'patch') {
          response = await patchData(action, {}, responseData, {
            api,
            requestData,
          })
        } else if (method === 'delete') {
          response = await deleteData(action, {}, formData, {})
        }
        data = response.data
        message = response.message
        status = response.status
        if (data) {
          objectPath.set(formData, `@response.${action.key}`, data)
          setFormData(formData)
        }
        if (status >= 400) {
          reject({
            status: status,
            data: null,
            message: message,
            api: action.api,
            apiName: action.apiName,
          })
        } else {
          resolve({
            status: status,
            data: data,
            message: message,
            api: action.api,
            apiName: action.apiName,
          })
        }
      })
        .then((response) => response)
        .catch((error) => error)
      promiseList.push(promise)
    })
    return {
      status: 200,
      responsePromise: promiseList,
    }
  }

  const crud = async (action, formData, hasErrorValidate, options = {}) => {
    if (!options.isEnterAction) {
      await new Promise((resolve) => setTimeout(resolve, 2000))
    }
    let promiseList = []
    let apiGroup = objectPath.get(action, 'crud.apiGroup') || []
    let apiSaveUpdate = objectPath.get(action, 'crud.apiSaveUpdate') || []
    let requireOnSubmit = objectPath.get(elementAction, 'requireOnSubmit') || {}
    let warningOnSubmit = objectPath.get(elementAction, 'warningOnSubmit') || {}
    let isRequired = false
    let isWarned = false
    Object.keys(requireOnSubmit).forEach((key) => {
      let hasShow = objectPath.has(elementAction, ['isShow', key])
      let show = objectPath.get(elementAction, ['isShow', key])
      if (hasShow && show === false) return
      let formValue = objectPath.get(formData, key)
      let requireMessage = objectPath.get(requireOnSubmit, key)
      if (!formValue && requireMessage) {
        objectPath.set(elementAction, ['isRequire', key], requireMessage)
        isRequired = true
      }
    })
    Object.keys(warningOnSubmit).forEach((key) => {
      let hasShow = objectPath.has(elementAction, ['isShow', key])
      let show = objectPath.get(elementAction, ['isShow', key])
      if (hasShow && show === false) return
      let formValue = objectPath.get(formData, key)
      let warningMessage = objectPath.get(warningOnSubmit, key)
      if (formValue && warningMessage) {
        objectPath.set(elementAction, ['isWarning', key], warningMessage)
        isWarned = true
      }
    })
    setElementAction(elementAction)
    if (isRequired) return await Promise.all(promiseList)
    if (isWarned) return await Promise.all(promiseList)

    let filterApi = []

    if (action.isSaveUpdate) {
      apiSaveUpdate.sort((a, b) => {
        let aKey = objectPath.get(a, 'found.key')
        let aIndex = apiGroup.findIndex((item) => item.key === aKey)
        let bKey = objectPath.get(b, 'found.key')
        let bIndex = apiGroup.findIndex((item) => item.key === bKey)
        return aIndex - bIndex
      })
      if (apiSaveUpdate.length > 0) {
        let index = 0
        let item = apiSaveUpdate[index]
        apiSaveUpdate.map((api) => {
          let foundKey = objectPath.get(api, 'found.key')
          api.found = apiGroup.find((api) => api.key === foundKey)
          let notfoundKey = objectPath.get(api, 'notfound.key')
          api.notfound = apiGroup.find((api) => api.key === notfoundKey)
          return api
        })
        promiseList = await saveSequence(
          item,
          index,
          promiseList,
          apiSaveUpdate,
          formData,
        )
      }
      return await Promise.all(promiseList)
    } else {
      let responseData = formData
      apiGroup.map(async (item, index) => {
        let promise = new Promise(async (resolve, reject) => {
          let method = item?.method || ''
          let response = {}
          let data = null
          let status = null
          let message = ''
          let ignoreValidate = item?.ignoreValidate ? true : false
          let awaitPromised = await Promise.all(promiseList)
          awaitPromised.forEach((data) => {
            if (data?.formData) {
              responseData = data.formData
            } else {
              responseData = formData
            }
          })
          let isPassCondition = checkConditionApi(
            item,
            allParams,
            responseData,
            datasourceValue,
            tabParamActive,
          )
          if (!ignoreValidate) {
            if (hasErrorValidate) {
              return resolve({
                status: -2,
                data: data,
                message: 'ERROR VALIDATE',
                api: item.api,
                apiName: item.apiName,
              })
            }
          }
          if (!isPassCondition) {
            return resolve({
              status: -1,
              data: data,
              message: 'SKIP API',
              api: item.api,
              apiName: item.apiName,
            })
          }
          if (item.requestDataType === 'file') {
            let acceptedFiles = objectPath.get(responseData, item.fileKey)
            if (_.isEmpty(acceptedFiles)) {
              return resolve({
                status: -2,
                data: null,
                message: 'Empty File',
                api: item.api,
                apiName: item.apiName,
              })
            }
            let browsePromise = await onBrowseFile(
              [item],
              formData,
              acceptedFiles,
              true,
            )
            browsePromise.forEach((response = {}) => {
              data = response.data
              message = response.message
              status = response.status
              if (status >= 400) {
                reject({
                  status: status,
                  data: null,
                  message: message,
                  api: item.api,
                  apiName: item.apiName,
                })
              } else {
                resolve({
                  status: status,
                  data: data,
                  message: message,
                  api: item.api,
                  apiName: item.apiName,
                  ignoreValidate,
                })
              }
            })
          } else if (item.isMultiRequest) {
            let response = await saveMultiRequest(item, {}, responseData)
            if (response.status === 500) {
              reject({
                ...response,
                api: item.api,
                apiName: item.apiName,
              })
            }
            let responsePromise = response.responsePromise
            if (responsePromise) {
              responsePromise.forEach(async (asyncRes = {}) => {
                let response = await asyncRes
                data = response.data
                message = response.message
                status = response.status
                if (status >= 400) {
                  reject({
                    status: status,
                    data: null,
                    message: message,
                    api: item.api,
                    apiName: item.apiName,
                  })
                } else {
                  resolve({
                    status: status,
                    data: data,
                    message: message,
                    api: item.api,
                    apiName: item.apiName,
                    ignoreValidate,
                  })
                }
              })
            }
          } else {
            if (method === 'get') {
              response = await getData(item, {}, formData)
            } else if (method === 'post') {
              response = await postData(item, {}, responseData, {})
            } else if (method === 'put') {
              response = await putData(item, {}, responseData, {})
            } else if (method === 'patch') {
              response = await patchData(item, {}, responseData, {})
            } else if (method === 'delete') {
              response = await deleteData(item, {}, formData, {})
            }
            if (response) {
              data = response.data
              message = response.message
              status = response.status
              if (data) {
                formData = mapResponseData(item, data, formData, {}, jsonForm)
                objectPath.set(formData, `@response.${item.key}`, data)
                setFormData(formData)
              }
            }
            if (status >= 400) {
              reject({
                status: status,
                data: null,
                message: message,
                api: item.api,
                apiName: item.apiName,
                formData,
              })
            } else {
              await fetchAfterSuccess({
                action: item,
                designContext,
                formData,
              })
              resolve({
                status: status,
                data: data,
                message: message,
                api: item.api,
                apiName: item.apiName,
                ignoreValidate,
                formData,
              })
            }
          }
        })
          .then((response) => response)
          .catch((error) => error)
        promiseList.push(promise)
      })
      return await Promise.all(promiseList)
    }
  }

  const refreshTablePanel = () => {
    let { isDetailPanel, renderTableData } = detailPanelProps
    if (isDetailPanel) {
      return renderTableData()
    }
    return null
  }

  const reload = ({ action, data, designContext }) => {
    if (action?.routerParams) {
      let { formData } = data
      let path = `${location.pathname}`
      let historyData = setHistoryData({
        action,
        path: '',
        designContext,
        formData,
      })
      history.push({
        pathname: path,
        search: historyData.search,
        state: null,
      })
    }
    window.location.reload()
  }

  const getAction = (action, formData, hasErrorValidate, options = {}) => {
    let routerDom = { history, location }
    let actionData = { ...data, formData }
    switch (action.name) {
      case 'goToForm':
        return goToForm({ action, data: actionData, designContext, routerDom })
      case 'goToPage':
        return goToPage({ action, data: actionData, designContext, routerDom })
      case 'goToUrl':
        return goToUrl({
          action,
          data: { ...actionData, urlParams: allParams, designContext },
        })
      case 'print':
        return print({ action, data: { ...actionData, designContext } })
      case 'backToReport':
        return backToReport({ designContext })
      case 'openModal':
        return openModal({
          action,
          data: actionData,
          designContext,
          uischema,
          setModalAction,
          setOpenModal,
        })
      case 'closeModal':
        return closeModal({
          action,
          data: actionData,
          designContext,
          uischema,
          setModalAction,
          setOpenModal,
        })
      case 'crud':
        return crud(action, formData, hasErrorValidate, options)
      case 'getData':
        return getData(action, {}, formData)
      case 'postData':
        return postData(action, {}, formData, {})
      case 'putData':
        return putData(action, {}, formData, {})
      case 'deleteData':
        return deleteData(action, {}, formData, {})
      case 'browseFile':
        return open()
      case 'uploadFile':
        return uploadFile({ action, data: actionData, designContext })
      case 'saveMedia':
        return saveMedia({ action, data: actionData, designContext })
      case 'refreshGallery':
        return refreshGallery({ action, designContext })
      case 'addToTable':
        return addToTable({ action, data: actionData, designContext })
      case 'updateToTable':
        return updateToTable({ action, data: actionData, designContext })
      case 'refreshTable':
        return refreshTable({ action, data: actionData, designContext })
      case 'refreshComponent':
        return refreshComponent({ action, data: actionData, designContext })
      case 'unselectRow':
        return unselectRow({ action, data: actionData, designContext })
      case 'resetData':
        return resetData({ action, data: actionData, designContext })
      case 'callback':
        return callbackFunction({ action, data: actionData, designContext })
      case 'showAndHide':
        return showAndHide({ action, designContext })
      case 'alert':
        return onAlert({
          action,
          doAction,
          designContext,
          buttonKey,
        })
      case 'searchAPI':
        return updateSearchAPI({ action, designContext, buttonKey })
      case 'searchField':
        return updateSearchField({ action, designContext })
      case 'fetchData':
        return fetchData({ data: actionData, designContext })
      case 'reload':
        return reload({ action, data: actionData, designContext })
      case 'openSmartCard':
        return setOpenSmartCard(!openSmartCard)
      case 'capture':
        return setOpenCapture(true)
      case 'drawing':
        return openDrawing({
          action,
          data: actionData,
          allParams,
          config,
          state: {
            drawing,
            setDrawing,
          },
        })
      case 'refButton':
        let { refButton } = action
        let refButtonKey = refButton?.key
        let refButtonUi = getCurrentUi(
          refButtonKey,
          jsonForm.schema,
          jsonForm.uischema,
        )
        return refButtonUi.key === refButtonKey && doRefAction(refButtonUi)
      case 'focusInput':
        return focusInput({ action, data: actionData, designContext })
      default:
        return
    }
  }

  const getLightDarkColor = (col, amt) => {
    let usePound = false
    if (col[0] == '#') {
      col = col.slice(1)
      usePound = true
    }
    let num = parseInt(col, 16)
    let r = (num >> 16) + amt
    if (r > 255) r = 255
    else if (r < 0) r = 0
    let b = ((num >> 8) & 0x00ff) + amt
    if (b > 255) b = 255
    else if (b < 0) b = 0
    let g = (num & 0x0000ff) + amt
    if (g > 255) g = 255
    else if (g < 0) g = 0
    return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
  }

  const getColorText = (color) => {
    let contrast = colorContrast('#fff', color)
    if (contrast >= 1.5) {
      return '#fff'
    }
    return '#000'
  }

  const getColorHover = (color) => {
    let contrast = colorContrast('#fff', color)
    if (contrast >= 2) {
      return getLightDarkColor(initialColor, 20)
    }
    return getLightDarkColor(initialColor, -20)
  }

  const initialColor = buttonColor ? buttonColor : '#4099ff'

  const styles = {
    default: {
      color: getColorText(initialColor),
      borderColor: initialColor,
      backgroundColor: initialColor,
    },
    defaultHover: {
      borderColor: getColorHover(initialColor),
      backgroundColor: getColorHover(initialColor),
    },
    outline: {
      color: initialColor,
      borderColor: initialColor,
      backgroundColor: 'transparent',
    },
    outlineHover: {
      color: getColorText(initialColor),
      borderColor: initialColor,
      backgroundColor: initialColor,
    },
    icon: {
      color: initialColor,
      borderColor: initialColor,
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
    left: {
      marginLeft: '0',
      marginRight: 'auto',
    },
    center: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    right: {
      marginLeft: 'auto',
      marginRight: '0',
    },
  }

  const getButtonPositionStyle = () => {
    if (uischema.buttonPosition === 'center') {
      return styles.center
    } else if (uischema.buttonPosition === 'right') {
      return styles.right
    }
    return styles.left
  }

  const getButtonStyle = (isHover = false) => {
    let style
    if (buttonType === 'outline') {
      style = isHover ? styles.outlineHover : styles.outline
    } else {
      style = isHover ? styles.defaultHover : styles.default
    }
    return {
      ...style,
      ...getButtonPositionStyle(),
      width: uischema.buttonWidth,
    }
  }

  const [styleChange, setStyleChange] = useState(() =>
    getButtonStyle(buttonKey === activeButton),
  )

  const handleHover = (isEnter) => {
    if (isEnter) {
      setStyleChange(getButtonStyle(true))
    } else {
      setStyleChange(getButtonStyle(buttonKey === activeButton))
    }
  }

  const showSuccessNoti = (afterAction) => {
    if (afterAction.isNotified) {
      let notice = PNotify.success({
        title: afterAction.notifySuccessTitle || 'Success',
        text: afterAction.notifySuccessText,
        icon: 'fas fa-check-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
    }
  }

  const showErrorNoti = (afterAction, response) => {
    let { message = '', apiName = '' } = response || {}
    if (afterAction.isNotified) {
      let notice = PNotify.error({
        title: afterAction.notifyErrorTitle || 'Error',
        text: JSON.stringify(message, null, 2) || afterAction.notifyErrorText,
        icon: 'fas fa-exclamation-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
      console.error(`Error Request:`, { apiName, message })
    }
  }

  const showValidationNoti = (hasErrorValidate) => {
    let notices = hasErrorValidate.notices || [
      {
        title: hasErrorValidate.title,
        items: hasErrorValidate,
      },
    ]

    notices.forEach(({ title, items }) => {
      let notice = PNotify.error({
        title,
        text: `${items.join('\n')}`,
        textTrusted: true,
        icon: 'fas fa-exclamation-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
    })
  }

  const showWarningNoti = (response = {}) => {
    let { message = '', apiName = '' } = response
    // let notice = PNotify.notice({
    //   title: message,
    //   text: `API: ${apiName}`,
    //   icon: 'fas fa-exclamation-circle fa-xl',
    // })
    // notice.on('click', function () {
    //   notice.close()
    // })
    console.warn(`Warning Request:`, { apiName, message })
  }

  const [isActive, setIsActive] = useState(false)
  const [isOnClick, setIsOnClick] = useState(false)
  const [doneAction, setDoneAction] = useState(false)
  const doneActionFormDataRef = useRef(formData)
  const afterSuccessResetActionRef = useRef(null)
  const uiChanged = objectPath.get(isUiChanged, buttonKey)
  const getButtonRuleKeys = () => {
    let keys = [buttonKey, fieldKey, fieldName]

    return keys.filter((key, index) => key && keys.indexOf(key) === index)
  }
  const onUpdateButtonRules = (data = formData, status = {}) => {
    if (!hasRules(jsonForm)) return

    onUpdateRules(props, designContext, buttonKey, data, {
      isDebounce: false,
      ruleUiKeys: getButtonRuleKeys(),
      ...status,
    })
  }

  useEffect(() => {
    if (uiChanged?.isActiveButton) {
      setActiveButton(buttonKey)
      onCheckCondition(designContext, formData, buttonKey, {
        isDebounce: false,
        isActive: true,
      })
      onUpdateButtonRules(formData, {
        isActive: true,
        eventKey: 'isActive',
      })
      doAction()
    }
  }, [uiChanged])

  useEffect(() => {
    if (uiChanged?.isClickButton) {
      const runTriggerButtonClick = async () => {
        try {
          let response = await handleClick({ waitAction: true })
          if (uiChanged.resolve) {
            uiChanged.resolve(response)
          }
        } catch (error) {
          if (uiChanged.reject) {
            uiChanged.reject(error)
          }
        } finally {
          objectPath.set(isUiChanged, buttonKey, { isClickButton: false })
          setIsUiChanged({ ...isUiChanged })
        }
      }

      runTriggerButtonClick()
    }
  }, [uiChanged])

  useEffect(() => {
    if (triggerButtonUiChanged?.isClickButton) {
      const runTriggerButtonClick = async () => {
        try {
          let response = await handleClick({ waitAction: true })
          if (triggerButtonUiChanged.resolve) {
            triggerButtonUiChanged.resolve(response)
          }
        } catch (error) {
          if (triggerButtonUiChanged.reject) {
            triggerButtonUiChanged.reject(error)
          }
        } finally {
          objectPath.set(
            isUiChanged,
            ['triggerButton', triggerButtonScopeKey, buttonKey],
            { isClickButton: false },
          )
          setIsUiChanged({ ...isUiChanged })
        }
      }

      runTriggerButtonClick()
    }
  }, [triggerButtonUiChanged])

  useEffect(() => {
    if (uiChanged?.doAction) {
      doAction()
      objectPath.set(isUiChanged, buttonKey, { doAction: false })
    }
  }, [uiChanged])

  useEffect(() => {
    if (objectPath.get(isUiChanged, ['enterRefAction', buttonKey])) {
      let refButtonUi = objectPath.get(isUiChanged, [
        'enterRefAction',
        buttonKey,
      ])
      enterRefAction(refButtonUi)
      objectPath.del(isUiChanged, ['enterRefAction', buttonKey])
      setIsUiChanged(isUiChanged)
    }
  }, [objectPath.get(isUiChanged, ['enterRefAction', buttonKey])])

  const updateActionList = async (actionList, actionFormData = formData) => {
    const responseList = await Promise.all(
      actionList.map(async (action) => {
        try {
          return await getAction(action, actionFormData)
        } catch (error) {
          return error
        }
      }),
    )
    let nextActionFormData = getActionListFormData(responseList, actionFormData)
    if (hasResponseFormData(responseList)) {
      setFormData(nextActionFormData)
    }
    return nextActionFormData
  }

  const getAfterSuccessResetActionList = (actionList = []) => {
    return actionList.filter((action = {}) => {
      return action.name === 'resetData' && action.resetType === 'form'
    })
  }

  const getAfterSuccessActionList = (actionList = []) => {
    return actionList.filter((action = {}) => {
      return !(action.name === 'resetData' && action.resetType === 'form')
    })
  }

  const resetAfterSuccessFormData = (
    ui = uischema,
    actionList = [],
    actionFormData = formData,
  ) => {
    let resetActionList = getAfterSuccessResetActionList(actionList)
    if (resetActionList.length === 0) return actionFormData

    resetActionList.forEach((action) => {
      let response = resetData({
        action,
        data: { ...data, formData: actionFormData },
        designContext,
      })
      actionFormData = response?.formData || actionFormData
    })

    return resetKey({
      keyList: getActionResponseResetKeyList({
        buttonAction: ui.action,
        actionList: resetActionList,
        allFormGroup,
        allApiGroup: [
          ...(jsonForm.apiGroup || []),
          ...(jsonForm.apiCondition || []),
        ],
      }),
      formData: actionFormData,
      designContext,
    })
  }

  const doAfterSuccess = async (ui = uischema, actionFormData = formData) => {
    let { afterSuccess = {} } = ui
    let actionList = afterSuccess?.isEnabled
      ? objectPath.get(afterSuccess, 'action') || []
      : []
    let resetActionList = getAfterSuccessResetActionList(actionList)
    let afterSuccessActionList = getAfterSuccessActionList(actionList)
    if (resetActionList.length > 0) {
      afterSuccessResetActionRef.current = {
        ui,
        actionList: resetActionList,
      }
    }
    await refreshTablePanel()
    setAfterSave(true)
    if (afterSuccess?.isEnabled) {
      actionFormData = await updateActionList(
        afterSuccessActionList,
        actionFormData,
      )
      designerPropsData = createDesignerData(
        designerPropsData,
        searchData,
        actionFormData,
      )
      setDesignerPropsData(designerPropsData)
    }
    doneActionFormDataRef.current = actionFormData
    setDoneAction(true)
  }

  const doAfterAction = async (afterAction, actionFormData = formData) => {
    if (!afterAction?.isEnabled) return actionFormData
    let actionList = objectPath.get(afterAction, 'action') || []
    return updateActionList(actionList, actionFormData)
  }

  const checkSuccessAlert = (
    { isSuccess, isWarning, isError, icon, title, text },
    response = {},
    hasErrorValidate,
    actionFormData = formData,
  ) => {
    if (action?.modalSuccess?.name) {
      const refreshIcon = feather.icons['rotate-cw'].toSvg({
        width: 14,
        height: 14,
        class: 'swal-feather-icon',
      })
      let swalObj = { icon, title, text }
      if (action.successAlert && isSuccess) {
        if (isModal) {
          swalObj = {
            ...swalObj,
            showCancelButton: false,
            confirmButtonText: `<i class="fa fa-arrow-circle-left"></i> กลับไปหน้าตาราง`,
            confirmButtonColor: '#46a3f9',
          }
          Swal.fire(swalObj).then((result) => {
            if (result.isConfirmed) {
              getAction(action?.modalSuccess, actionFormData, hasErrorValidate)
            }
          })
        } else {
          swalObj = {
            ...swalObj,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `${refreshIcon} กลับไปหน้าข้อมูล`,
            confirmButtonColor: '#46a3f9',
            denyButtonText: `<i class="fa fa-arrow-circle-left"></i> กลับไปหน้าตาราง`,
            denyButtonColor: '#6e7685',
          }
          Swal.fire(swalObj).then((result) => {
            if (result.isConfirmed) {
              reload({
                action: action?.reloadSuccess,
                data: { formData: actionFormData },
                designContext,
              })
            } else if (result.isDenied) {
              getAction(action?.modalSuccess, actionFormData, hasErrorValidate)
            }
          })
        }
      } else if (isWarning || isError) {
        let html = ''
        if (!text) {
          if (Array.isArray(response)) {
            response.forEach(({ apiName, message }, index) => {
              html += `<p class="font-weight-bold mb-0" style="text-align:left;font-size:16px">${
                index + 1
              }. ${apiName}</p>`
              html += `<p class="text-danger" style="text-align:left;font-size:16px">- ${message.message}</p>`
            })
          } else {
            let { message = '' } = response
            html = JSON.stringify(message, null, 2)
          }
        }
        if (html) {
          swalObj = {
            ...swalObj,
            html,
          }
        } else {
          swalObj = {
            ...swalObj,
            text,
          }
        }
        swalObj = {
          ...swalObj,
          width: 800,
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `<i class="fa fa-arrow-circle-left"></i> กลับไปแก้ไข`,
          confirmButtonColor: '#fda129',
        }
        Swal.fire(swalObj).then((result) => {
          if (result.isConfirmed) {
            Swal.close()
          }
        })
      }
    } else {
      if (action.loadingAlert) {
        Swal.close()
      }
    }
  }

  const doAction = async (options = {}) => {
    let { action = {}, afterAction = {} } = uischema
    if (action.name !== 'resetData') {
      setIsResetData(false)
    }
    let eventButton = objectPath.get(uischema, 'action.event')
    if (eventButton === 'onActive') {
      setActiveButton(buttonKey)
      onCheckCondition(designContext, formData, buttonKey, {
        isDebounce: false,
        isActive: true,
      })
      onUpdateButtonRules(formData, {
        isActive: true,
        eventKey: 'isActive',
      })
      setIsActive(true)
      setIsOnClick(false)
    } else {
      if (isLoading) {
        return
      }
      setIsLoading(true)
      setActiveButton(null)
      setIsActive(false)
      setIsOnClick(true)
    }
    let hasErrorValidate = openLoadingAlert(action)
    if (
      shouldStopTriggerButtonAction({
        waitAction: options?.waitAction === true,
        hasErrorValidate,
      })
    ) {
      closeLoadingAlert(action)
      setIsLoading(false)
      let response = createTriggerButtonValidateResponse({
        formData,
        hasErrorValidate,
      })
      await doAfterResponse(response, hasErrorValidate, formData)
      return response
    }
    let response
    try {
      response = await getAction(action, formData, hasErrorValidate)
      if (options?.waitAction === true) {
        response = createTriggerButtonResultWithValidate({
          response,
          formData,
          hasErrorValidate,
        })
      }
    } finally {
      closeLoadingAlert(action)
      setIsLoading(false)
    }
    let responseFormData = getResponseFormData(response, formData)
    responseFormData = await doAfterAction(afterAction, responseFormData)
    await doAfterResponse(response, hasErrorValidate, responseFormData)
    return response
  }

  const doRefAction = async (uischema) => {
    let { action = {} } = uischema
    if (action.name !== 'resetData') {
      setIsResetData(false)
    }
    let hasErrorValidate
    if (action.name === 'crud') {
      let {
        buttonTextOnClick = 'Saving...',
        loadingAlertText = 'กำลังบันทึกข้อมูล...',
      } = action
      setLoadingText(buttonTextOnClick)
      hasErrorValidate = validate(formData)
      if (action.loadingAlert) {
        Swal.fire({
          title: loadingAlertText,
          showConfirmButton: false,
          returnFocus: false,
          focusConfirm: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading()
          },
        })
      }
    } else {
      setLoadingText('Loading...')
    }
    let response
    try {
      response = await getAction(action, formData, hasErrorValidate)
    } finally {
      closeLoadingAlert(action)
      setIsLoading(false)
    }
    return response
  }

  const doAfterResponse = async (
    response,
    hasErrorValidate,
    responseFormData = formData,
  ) => {
    let { afterAction = {} } = uischema
    if (Array.isArray(response)) {
      let foundError = response.filter((response = {}) => {
        let { status } = response
        if (status === -2) {
          showWarningNoti(response)
        }
        return status === null || status >= 400
      })
      foundError.forEach((response = {}) => {
        showErrorNoti(afterAction, response)
      })
      let foundSuccess = response.filter((response = {}) => {
        let { status } = response
        return status >= 200 && status < 300
      })
      let foundIgnoreValidate = response.filter((response = {}) => {
        let { ignoreValidate } = response
        return ignoreValidate
      })
      if (hasErrorValidate && foundIgnoreValidate.length !== response.length) {
        showValidationNoti(hasErrorValidate)
        checkSuccessAlert(
          {
            isWarning: true,
            icon: 'warning',
            title: hasErrorValidate.title,
            text: `${hasErrorValidate.join('\n')}`,
          },
          foundIgnoreValidate,
          hasErrorValidate,
          responseFormData,
        )
      }
      if (foundSuccess.length > 0) {
        let actionFormData = getResponseFormData(foundSuccess, responseFormData)
        setFormData(actionFormData)
        showSuccessNoti(afterAction)
        if (foundError.length === 0) {
          await doAfterSuccess(uischema, actionFormData)
        }
        checkSuccessAlert(
          { isSuccess: true, icon: 'success', title: 'บันทึกสำเร็จ' },
          response,
          hasErrorValidate,
          actionFormData,
        )
      }
      if (foundError.length > 0) {
        checkSuccessAlert(
          { isError: true, icon: 'error', title: 'ไม่สามารถบันทึกได้' },
          foundError,
          hasErrorValidate,
          responseFormData,
        )
      }
    } else {
      let { status, data = null, ignoreValidate } = response || {}
      let actionFormData = responseFormData
      if (data) {
        actionFormData = getResponseFormData(response, responseFormData)
        setFormData(actionFormData)
      }
      if (hasErrorValidate && !ignoreValidate) {
        showValidationNoti(hasErrorValidate)
        checkSuccessAlert(
          {
            isWarning: true,
            icon: 'warning',
            title: hasErrorValidate.title,
            text: `${hasErrorValidate.join('\n')}`,
          },
          response,
          hasErrorValidate,
          actionFormData,
        )
      }
      if (status === -2) {
        showWarningNoti(response)
        checkSuccessAlert(
          { isWarning: true, icon: 'warning', title: 'Warning!' },
          response,
          hasErrorValidate,
          actionFormData,
        )
      } else if (status >= 200 && status < 300) {
        showSuccessNoti(afterAction)
        await doAfterSuccess(uischema, actionFormData)
        checkSuccessAlert(
          { isSuccess: true, icon: 'success', title: 'บันทึกสำเร็จ' },
          response,
          hasErrorValidate,
          actionFormData,
        )
      } else {
        showErrorNoti(afterAction, response)
        checkSuccessAlert(
          { isError: true, icon: 'error', title: 'ไม่สามารถบันทึกได้' },
          response,
          hasErrorValidate,
          actionFormData,
        )
      }
    }
  }

  const openLoadingAlert = (action) => {
    let hasErrorValidate
    if (action.name === 'crud') {
      let {
        buttonTextOnClick = 'Saving...',
        loadingAlertText = 'กำลังบันทึกข้อมูล...',
      } = action
      setLoadingText(buttonTextOnClick)
      hasErrorValidate = validate(formData)
      if (action.loadingAlert) {
        Swal.fire({
          title: loadingAlertText,
          showConfirmButton: false,
          returnFocus: false,
          focusConfirm: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading()
          },
        })
      }
    } else {
      setLoadingText('Loading...')
    }
    return hasErrorValidate
  }

  const closeLoadingAlert = (action) => {
    if (action.loadingAlert) {
      Swal.close()
    }
  }

  const enterRefAction = async (uischema) => {
    let { action = {}, afterAction = {} } = uischema
    if (action.name !== 'resetData') {
      setIsResetData(false)
    }
    let hasErrorValidate = openLoadingAlert(action)
    let response
    try {
      response = await getAction(action, formData, hasErrorValidate, {
        isEnterAction: true,
      })
    } finally {
      closeLoadingAlert(action)
      setIsLoading(false)
    }
    let responseFormData = getResponseFormData(response, formData)
    responseFormData = await doAfterAction(afterAction, responseFormData)
    await doAfterResponse(response, hasErrorValidate, responseFormData)
  }

  useEffect(() => {
    if (!drawing) return
    const timer = setInterval(() => {
      if (drawing.closed) {
        doAfterSuccess()
        setDrawing(null)
        clearInterval(timer)
      }
    }, 500)

    return () => clearInterval(timer)
  }, [drawing])

  useEffect(() => {
    if (doneAction) {
      let actionFormData = doneActionFormDataRef.current || formData
      let resetAction = afterSuccessResetActionRef.current
      let resetRuleUiKeys = []
      if (resetAction) {
        resetRuleUiKeys = Object.keys(
          {
            ...getActionResetKeyList({
              actionList: resetAction.actionList,
              allFormGroup,
            }),
            ...getActionResponseResetKeyList({
              buttonAction: resetAction.ui.action,
              actionList: resetAction.actionList,
              allFormGroup,
              allApiGroup: [
                ...(jsonForm.apiGroup || []),
                ...(jsonForm.apiCondition || []),
              ],
            }),
          },
        )
        actionFormData = resetAfterSuccessFormData(
          resetAction.ui,
          resetAction.actionList,
          actionFormData,
        )
        doneActionFormDataRef.current = actionFormData
        afterSuccessResetActionRef.current = null
      }
      onUpdateCondition(props, designContext, buttonKey, actionFormData, {
        isActive,
        isOnClick,
        isDebounce: false,
        isAfterSuccess: true,
      })
      if (resetRuleUiKeys.length > 0) {
        onUpdateRules(props, designContext, resetRuleUiKeys, actionFormData, {
          isDebounce: false,
          isOnChange: true,
          eventKey: 'onChange',
          ruleUiKeys: resetRuleUiKeys,
          valueChange: undefined,
          valueChangeUiKeys: resetRuleUiKeys,
        })
      }
      onUpdateButtonRules(actionFormData, {
        isActive,
        isOnClick,
        isAfterSuccess: true,
        eventKey: 'afterActionSuccess',
      })
      setDoneAction(false)
    }
  }, [doneAction])

  const validate = (values) => {
    let errors = checkError(jsonForm, values)
    let hasErrorValidate = Object.values(errors).find((item) => {
      return item.length > 0
    })
    if (hasErrorValidate) {
      let listItem = []
      let validationNotices = []
      let validationTitle = getValidationAlertTitle(errors)
      Object.keys(errors).forEach((key) => {
        let item = errors[key]
        if (item.length > 0) {
          let ui = getCurrentUi(key)
          let name
          let regex = new RegExp('field', 'ig')
          if (regex.test(ui.fieldName)) {
            name = ui.label || ui.name
          } else {
            name = ui.fieldName || ui.label
          }
          let fieldItem = `- ${name}`
          let fieldTitle = getValidationAlertTitle({ [key]: item })
          let validationNotice = validationNotices.find(
            ({ title }) => title === fieldTitle,
          )
          if (validationNotice) {
            validationNotice.items.push(fieldItem)
          } else {
            validationNotices.push({
              title: fieldTitle,
              items: [fieldItem],
            })
          }
          listItem.push(fieldItem)
        }
      })
      hasErrorValidate = Object.assign(listItem, {
        notices: validationNotices,
        title: validationTitle,
      })
    }

    return hasErrorValidate
  }

  useEffect(() => {
    setStyleChange(getButtonStyle(buttonKey === activeButton))
  }, [buttonColor, buttonType, uischema.buttonWidth, uischema.buttonPosition])

  const [isStart, setIsStart] = useState(true)
  const [afterSave, setAfterSave] = useState(false)

  const formCode =
    objectPath.get(match, 'params.formCode') ||
    objectPath.get(match, 'params.pageCode')

  useEffect(() => {
    setIsStart(true)
  }, [formCode])

  useEffect(() => {
    if (action.isAutoSave) {
      if (afterSave) return setAfterSave(false)
      if (isStart) return setIsStart(false)
      let autoSaveTime = action.autoSaveTime
      let checkAutoSave = autoSaveTime && autoSaveTime > 0
      let delay = checkAutoSave ? autoSaveTime * 1000 : DEBOUNCE_SAVE_DELAY_MS
      debounceCallback(doAction, [], 'autoSaveAction', delay)
    }
  }, [JSON.stringify(formData)])

  useEffect(() => {
    setStyleChange(getButtonStyle(buttonKey === activeButton))
  }, [activeButton])

  useEffect(() => {
    let { conditionKey, actionKey = [], actionValue = [] } = elementAction || {}
    if (!conditionKey) return
    conditionKey.forEach((list, index) => {
      let found = list.find((key) => key === buttonKey)
      if (found) {
        let foundAction = actionKey[index]
        let foundValue = actionValue[index]
        let isActive = false
        if (foundAction) {
          foundAction.forEach((inputKey) => {
            let { defaultValue } = getCurrentUi(inputKey)
            let value = objectPath.get(foundValue, inputKey)
            if (value === defaultValue) {
              isActive = objectPath.has(elementAction, [buttonKey, 'isActive'])
            } else {
              isActive = uischema.defaultActived || false
            }
          })
        }
        if (isActive) {
          setActiveButton(buttonKey)
          onCheckCondition(designContext, formData, buttonKey, {
            isDebounce: false,
            isActive: true,
          })
          onUpdateButtonRules(formData, {
            isActive: true,
            eventKey: 'isActive',
          })
        }
      }
    })
  }, [])

  const handleClick = async (options = {}) => {
    let waitAction = options?.waitAction === true
    let response

    console.log(';customClick ', customClick, uischema)
    objectPath.set(formData, buttonKey, true)
    // setValues(formData)

    try {
      if (customClick) {
        response = onCustomClick()
        if (waitAction) {
          response = await response
        }
      } else {
        let beforeAction = objectPath.get(uischema, 'beforeAction') || {}
        if (beforeAction.isEnabled) {
          response = onBeforeAlert({
            action: beforeAction,
            formData,
            doAction,
            designContext,
            buttonKey,
            data,
            uischema,
            setModalAction,
            setOpenModal,
          })
          setFormData(formData)
        } else {
          let eventButton = objectPath.get(uischema, 'action.event')
          if (eventButton === 'onClick') {
            onCheckCondition(designContext, formData, buttonKey, {
              isDebounce: false,
              isOnClick: true,
            })
            onUpdateButtonRules(formData, {
              isOnClick: true,
              eventKey: 'onClick',
            })
          }
          response = doAction({ waitAction })
          if (action.name !== 'resetData') {
            setFormData(formData)
          }
          if (waitAction) {
            response = await response
          }
        }
      }
      return response
    } finally {
      objectPath.set(formData, buttonKey, false)
    }
  }

  const renderActionState = ({ isShowAttachment = true } = {}) => {
    return (
      <>
        {isShowAttachment && isShowAttachmentView && (
          <Row className="w-100 mx-0 mt-2">
            <AttachmentView uiKey={buttonKey} />
          </Row>
        )}

        {triggerModal[buttonKey] && designContext.openModal === buttonKey && (
          <ModalButton
            {...props}
            ui={uischema}
            modalAction={modalAction}
            isOpenModal={objectPath.has(triggerModal, [buttonKey])}
            designerPropsData={jsonForm.designerPropsData}
          />
        )}
        {openSmartCard && (
          <SmartCard
            open={openSmartCard}
            onClose={() => setOpenSmartCard(!openSmartCard)}
            action={action}
            data={data}
          />
        )}
        {openCapture && (
          <Capture
            open={openCapture}
            onClose={() => setOpenCapture(false)}
            action={action}
            config={props.config}
          />
        )}
      </>
    )
  }

  if (isLocked) {
    return <></>
  }

  if (actionOnly && renderAction) {
    return (
      <>
        {renderAction({
          onClick: handleClick,
          disabled: isLoading || isDisable,
          isLoading,
          loadingText,
        })}
        {renderActionState({ isShowAttachment: false })}
      </>
    )
  }

  return (
    <Form.Group
      className="mb-0"
      controlId={uischema.controlId}
      hidden={!isShowUi || action.isAutoSave}
    >
      <Row className="w-100 mx-0">
        <Label
          {...props}
          uischema={uischema}
          label={label}
          isEnable={!isReadOnly}
        />
        <Col sm={uischema.elementWidth} className="p-0 mt-1 d-flex">
          {buttonType === 'icon' ? (
            <Icon
              iconName={uischema.buttonIcon}
              id={fieldKey}
              name={fieldName}
              style={{ ...styles.icon }}
              onClick={handleClick}
              size="16"
              disabled={isLoading || isDisable}
              onMouseEnter={() => handleHover(true)}
              onMouseLeave={() => handleHover(false)}
            />
          ) : (
            <Button
              id={fieldKey}
              name={fieldName}
              style={styleChange}
              onClick={handleClick}
              disabled={isLoading || isDisable}
              onMouseEnter={() => handleHover(true)}
              onMouseLeave={() => handleHover(false)}
            >
              <span
                style={
                  uischema.buttonIconSource === 'feather'
                    ? {
                        top: '-1px',
                        position: 'relative',
                      }
                    : {}
                }
                className={buttonText && 'mr-1'}
              >
                <Icon iconName={uischema.buttonIcon} />
              </span>
              {isLoading ? loadingText : buttonText}
            </Button>
          )}
        </Col>
      </Row>
      {renderActionState()}
    </Form.Group>
  )
}

const OverlayCustomButton = (props) => {
  let { uischema } = props
  let action = objectPath.get(uischema, 'action') || {}
  let { tooltipText } = action

  if (tooltipText) {
    return (
      <Tooltip
        title={<span style={{ fontSize: '14px' }}>{tooltipText}</span>}
        arrow
      >
        <span>
          <CustomButton {...props} />
        </span>
      </Tooltip>
    )
  }

  return <CustomButton {...props} />
}

export default OverlayCustomButton
